import React, { useState, useEffect } from "react";
import "./popup.css";
import cibfLogo from '../../assets/icons/cibfLogo.svg';
import cibfLogoCol from '../../assets/icons/cibfColLogo.svg';
import pinIcon from '../../assets/icons/pinIcon.svg';
import clockIcon from '../../assets/icons/clockIcon.svg';
import Btn from "../common/btn";
import { Link } from "react-router-dom";
import { supabase } from "../../supabase";

export default function Modal() {
  const [modal, setModal] = useState(false);
  const [popupContent, setPopupContent] = useState(null);

  const toggleModal = () => {
    setModal(!modal);
  };

  const loadScheduledPopup = async () => {
    const now = new Date();

    const { data, error } = await supabase
      .from("scheduled_content")
      .select("*")
      .eq("type", "Popup")
      .eq("status", "Scheduled")
      .order("scheduled_date", { ascending: true })
      .order("scheduled_time", { ascending: true });

    if (error) {
      console.error("Popup load failed:", error.message);
      return;
    }

    const activePopup = data?.find((item) => {
      const popupDateTime = new Date(`${item.scheduled_date}T${item.scheduled_time}`);
      return popupDateTime <= now;
    });

    setPopupContent(activePopup || null);
  };

  useEffect(() => {
    loadScheduledPopup();

    const channel = supabase
      .channel("scheduled_popup_changes")
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "scheduled_content",
        },
        () => loadScheduledPopup()
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  useEffect(() => {
    if (!popupContent) return;

    const timer = setTimeout(() => {
      setModal(true);
    }, 7000);

    return () => clearTimeout(timer);
  }, [popupContent]);

  useEffect(() => {
    if (modal) {
      document.body.classList.add("active-modal");
    } else {
      document.body.classList.remove("active-modal");
    }

    return () => {
      document.body.classList.remove("active-modal");
    };
  }, [modal]);

  if (!popupContent) return null;

  return (
    <>
      {modal && (
        <div className="modal">
          <div onClick={toggleModal} className="overlay"></div>

          <div className="modal-content">
            <img
              className="displayNone"
              src={cibfLogoCol}
              alt="Cairo International Book Fair logo"
            />

            <img
              className="displayFlex"
              src={cibfLogo}
              alt="Cairo International Book Fair logo"
            />

            <div className="gap12">
              <div className="gap12">
                <h2>{popupContent.title || "Save the date!"}</h2>

                <div className="popUpExpoDate">
                  <h3>{popupContent.subtitle || "January 25 - February 7"}</h3>
                  <h4>{popupContent.year || "2027"}</h4>
                </div>
              </div>

              <div className="popUpExpoDetails">
                <div className="popUpExpoDetail">
                  <img src={pinIcon} alt="Location Icon" />
                  <p>{popupContent.location || "Egypt's International Exhibition Center"}</p>
                </div>

                <div className="popUpExpoDetail">
                  <img src={clockIcon} alt="Clock Icon" />
                  <p>{popupContent.time_text || "10:00 AM - 9:00 PM Daily"}</p>
                </div>
              </div>
            </div>

            <Link className="link" to={popupContent.button_url || "/Book"}>
              <Btn
                btnText={popupContent.button_text || "Book your Ticket Now!"}
                btnStyle="popUpBtn"
              />
            </Link>

            <button className="close-modal" onClick={toggleModal}>
              X
            </button>
          </div>
        </div>
      )}
    </>
  );
}